import {
    createLazyComponent,
    LazyModule,
    registerLazyOrchestrator,
    type LazyComponent,
} from 'owa-bundling';
import { onModuleClick } from 'owa-workloads';
import type * as lazyIndex from './lazyIndex';
import type { CopilotAccountBannerProps } from './components/CopilotAccountBanner';
import type { CopilotAccountPickerDialogProps } from './components/CopilotAccountPickerDialog';
import type { CopilotAccountSwitcherProps } from './components/CopilotAccountSwitcher';

// Create lazy module for components
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "CopilotAccountPickerDialog" */ './lazyIndex'),
    { name: 'CopilotAccountPickerDialog' }
);

// Lazy-loaded components
export const CopilotAccountBanner: LazyComponent<CopilotAccountBannerProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CopilotAccountBanner);

export const CopilotAccountPickerDialog: LazyComponent<
    CopilotAccountPickerDialogProps,
    unknown,
    void
> = createLazyComponent(lazyModule, m => m.CopilotAccountPickerDialog);

export const CopilotAccountSwitcher: LazyComponent<CopilotAccountSwitcherProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.CopilotAccountSwitcher);

// Re-export types (types don't add to bundle size)
export type { CopilotAccountBannerProps } from './components/CopilotAccountBanner';
export type { CopilotAccountPickerDialogProps } from './components/CopilotAccountPickerDialog';
export type { CopilotAccountSwitcherProps } from './components/CopilotAccountSwitcher';
export type { CopilotAccountOption } from './store/schema/CopilotAccountPickerStoreSchema';

// External API - only exports needed by consumers (CopilotChatDrawer)
export { getCurrentAccount } from './selectors/getCurrentAccount';
export { resetCopilotAccountPickerDialogStoreMutator } from './mutators/accountPickerMutators';

// Register lazy orchestrator
registerLazyOrchestrator(onModuleClick, lazyModule, m => m.resetStoreOnModuleChangeOrchestrator);
